export default "__VITE_ASSET__D0jygn8G__"